import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { setUser } from 'src/store/auth/slice';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';
import { AuthApi } from 'src/api/base/Auth';
import { useFetch } from 'src/utils/hooks/useFetch';
import { IRegisterAsExpert1Model } from 'src/api/base/Auth/types';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { ExpertForm } from './ExpertForm';
import { setAuthTokenInSystem } from 'src/store/auth/asyncThunk';

type PExpertFormContainer = {
  isVerticalForm?: boolean;
};

export const ExpertFormContainer: React.FC<PExpertFormContainer> = () => {
  const [{ response, isLoading, error }, doFetch] = useFetch<
    any,
    IRegisterAsExpert1Model
  >(AuthApi.registerAsExpert1);

  useResponseFormHandler({ error });
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (response) {
      dispatch(setUser(response?.data?.user));
      setAuthTokenInSystem(response?.data?.access_token);
      history.push(APP_ROUTES.REG_AS_EXPERT2);
    }
  }, [response, history, dispatch]);

  return (
    <ExpertForm
      onSubmit={(data) => {
        doFetch(data);
      }}
      errors={error?.response?.data.errors}
      loading={isLoading}
    />
  );
};
